export default "__VITE_ASSET__nCXjgtz2__"